<template>
    <div class="overlay " @click="closePopover">
        <div class="popup" :style="cssVars" @click.stop="">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: "popover",
    props:{
        isShowing: Boolean,
        width: {
            type: String,
            default: "80%"
        },
        height: {
            type: String,
            default: "80%"
        }
    },
    methods:{
        closePopover: function(){
            this.$emit('close');
        }
    },
    computed: {
        cssVars(){
            return {
                "--width": this.width,
                "--height": this.height,
            }
        },
    }
}
</script>

<style lang="scss" scoped>

    @import "../../assets/styles/_globals";

    .overlay {
        height:100%;
        width:100%;
        z-index:1000;
        position: absolute;
        top:0;
        left:0;
        background-color: rgba($sec_shadow_color, 0.7);
    }

    .popup {
        width: var(--width);
        height: var(--height);
        background-color: $prim_bg_color;
        margin: 0 auto;
        border: solid 1px $prim_border_color;
        border-radius: $border_radius_default;
        margin-top: 100px;
    }

</style>